export default {
  methods: {
    closeModal(payload = '') {
      this.$modal.close(payload);
    }
  }
}